import Sidebar from './SideBar.vue'

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [
    {
      name: 'Account Settings',
      icon: 'ti-user',
      path: '/account-settings'
    },
    {
      name: 'Restaurants',
      icon: 'ti-location-pin',
      path: '/restaurants'
    },
    {
      name: 'Location Summary',
      icon: 'ti-angle-right',
      path: '/payments'
    },
    // {
    //   name: 'Reports',
    //   icon: 'ti-bar-chart',
    //   path: '/invoice-report'
    // },
    {
      name: ' Orders/Invoice Report',
      icon: 'ti-angle-right',
      path: '/invoice-report'
    },
    // {
    //   name: 'Invoice Detail Report',
    //   icon: 'ti-angle-right',
    //   path: '/invoice-detail'
    // },
    // {
    //   name: 'Summary Report',
    //   icon: 'ti-angle-right',
    //   path: '/restaurant-summary'
    // },
    {
      name: 'Adjustments Report',
      icon: 'ti-angle-right',
      path: '/errors-report'
    },
    {
      name: 'Order Ratings',
      icon: 'ti-angle-right',
      path: '/order-ratings'
    },
    {
      name: 'Customer Info',
      icon: 'ti-angle-right',
      path: '/customers'
    },
    // {
    //   name: 'Support',
    //   icon: 'ti-help-alt',
    //   path: '/support'
    // }
  ],
  displaySidebar (value) {
    this.showSidebar = value
  }
}

const SidebarPlugin = {

  install (Vue) {
    Vue.mixin({
      data () {
        return {
          sidebarStore: SidebarStore
        }
      }
    })

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get () {
        return this.$root.sidebarStore
      }
    })
    Vue.component('side-bar', Sidebar)
  }
}

export default SidebarPlugin



// WEBPACK FOOTER //
// ./src/components/UIComponents/SidebarPlugin/index.js